var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLearning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M772 567c14 0 25 12 25 25v80c0 10-6 20-16 23l-231 90c-24 9-50 9-73 0l-226-90c-9-3-16-13-16-23v-80c0-3 1-5 2-8 5-13 19-20 32-15l213 77c22 8 46 8 69 0l213-77c2-1 5-2 8-2zM557 217l362 139c20 8 29 29 22 49-4 9-11 17-21 21l-2 1v219c21 9 34 35 40 77 4 26-15 50-41 54h-32c-26 0-48-21-48-48 0-2 0-4 1-6 5-44 20-70 42-78V442L562 572c-30 12-64 12-94 0L107 426c-19-8-29-30-21-49 4-10 12-17 21-21l360-139c29-12 61-12 90 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLearning);
export default __webpack_public_path__ + "static/media/ic_learning.4da23699cba5d484204773e28e1769d9.svg";
export { ForwardRef as ReactComponent };